class HistoryManager {
  constructor() {
    this.activeCanvasId = null;
    this.lastCreatedCanvasId = null;
    this.lastGeneratedCanvasCode = '';
    this.lastEditedCanvasCode = '';
    this.eventHistory = '';
    this.fetchedMessagesContext = null;
  }

  setActiveCanvas(id) {
    console.log(`historyManager: Setting active canvas ID to ${id}`);
    this.activeCanvasId = id;
  }

  setLastCreatedCanvasId(id) {
    console.log(`historyManager: Setting last created canvas ID to ${id}`);
    this.lastCreatedCanvasId = id;
  }

  setGeneratedCanvasCode(code) {
    console.log(`historyManager: Setting generated canvas code (length: ${code?.length || 0})`);
    this.lastGeneratedCanvasCode = code;
  }

  setEditedCanvasCode(code) {
    console.log(`historyManager: Setting edited canvas code (length: ${code?.length || 0})`);
    this.lastEditedCanvasCode = code;
  }

  addEvent(event) {
    this.eventHistory += `${event}\n`;
  }

  constructQueryMessage(userQuery) {
    let message = '';

    // Add last generated canvas code if any
    if (this.lastGeneratedCanvasCode) {
      // Use the last created canvas ID for the canvasCreate returned message
      if (this.lastCreatedCanvasId) {
        message += `canvasCreate returned (id-${this.lastCreatedCanvasId}):\n${this.lastGeneratedCanvasCode}\n\n`;
        this.lastCreatedCanvasId = null; // Clear after use
      } else if (this.activeCanvasId) {
        // Fallback to active canvas ID if last created ID is not available
        message += `canvasCreate returned (id-${this.activeCanvasId}):\n${this.lastGeneratedCanvasCode}\n\n`;
      } else {
        console.warn('Warning: Generated canvas code exists but no canvas ID is set');
        message += `canvasCreate returned:\n${this.lastGeneratedCanvasCode}\n\n`;
      }
      this.lastGeneratedCanvasCode = ''; // Clear after use
    }

    // Add last edited canvas code if any
    if (this.lastEditedCanvasCode) {
      message += `canvasEdit returned:\n${this.lastEditedCanvasCode}\n\n`;
      this.lastEditedCanvasCode = ''; // Clear after use
    }

    // Add event history if any
    if (this.eventHistory) {
      message += `Event History:\n${this.eventHistory}\n\n`;
      this.eventHistory = ''; // Clear after use
    }
    
    // Add fetched messages context if any
    if (this.fetchedMessagesContext) {
      console.log('Adding fetched messages context to query');
      // We don't clear this here as it will be handled by the backend
      // It will be cleared after the next query response is processed
    }

    // Check if this is an automatic message about canvas creation/editing
    const isCanvasStatusMessage = 
      userQuery === 'Canvas has been created' || 
      userQuery === 'Canvas has been edited' ||
      userQuery.startsWith('Canvas code for id-');
    
    // Add active canvas information with id- prefix
    if (this.activeCanvasId) {
      message += `Current Canvas: id-${this.activeCanvasId}\n\n`;
    }
    
    // Add user query with quotes, but don't add "User Query:" prefix for automatic canvas messages
    if (isCanvasStatusMessage) {
      message += userQuery;
    } else {
      message += `User Query:\n"${userQuery}"`;
    }

    return message;
  }

  setFetchedMessagesContext(context) {
    console.log('historyManager: Setting fetched messages context');
    this.fetchedMessagesContext = context;
  }

  clear() {
    this.activeCanvasId = null;
    this.lastCreatedCanvasId = null;
    this.lastGeneratedCanvasCode = '';
    this.lastEditedCanvasCode = '';
    this.eventHistory = '';
    this.fetchedMessagesContext = null;
  }
}

// Create a singleton instance
const historyManager = new HistoryManager();
export default historyManager;